import React from 'react';

import cn from 'classnames';
import { useRouteMatch } from 'react-router';

import NestedLink from 'components/NestedLink';
import Typography from 'components/Typography';

import { ParticipantsType, Speaker } from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';

export type SpeakerTagType = Pick<Speaker, 'id' | 'name'> & {
  participantsType: Pick<ParticipantsType, 'slug'>;
};

interface IProps {
  speaker: SpeakerTagType;
  onClick?: () => void;
  className?: string;
}

const GENDER_BG_CLASSES: Record<string, string> = {
  FEMALE: 'bg-gender-female',
  MALE: 'bg-gender-male',
  DIVERSE: 'bg-gender-non-binary',
  FEMALE_FEMALE: 'bg-gender-couple',
  FEMALE_MALE: 'bg-gender-couple',
  MALE_FEMALE: 'bg-gender-couple',
  MALE_MALE: 'bg-gender-couple',
  ANONYM: 'bg-gender-anonymous',
};

const SpeakerTag = ({ speaker, onClick, className }: IProps) => {
  const {
    params: { section = '' },
  } = useRouteMatch<{ section?: string }>();

  const { isAuthenticated } = useAuth();

  const genderKey = speaker.participantsType?.slug?.toUpperCase() || 'FEMALE';
  const bgClass = GENDER_BG_CLASSES[genderKey] || GENDER_BG_CLASSES.FEMALE;

  return (
    <div
      className={cn(
        'SpeakerTag overflow-hidden',
        className,
        `SpeakerTag--${genderKey}`,
      )}
    >
      {isAuthenticated ? (
        <NestedLink
          onClick={(e) => {
            e.stopPropagation();

            if (onClick) {
              onClick();
              e.preventDefault();
            }
          }}
          to={`${section || 'browse'}/speakers/${speaker.id}/stories`}
        >
          <Typography color="white" variant="h4" className="flex">
            <span
              className={cn(
                'SpeakerTag--Text py-0.5 px-2 rounded-lg truncate w-full inline-block no-underline',
                bgClass,
              )}
            >
              {speaker.name}
            </span>
          </Typography>
        </NestedLink>
      ) : (
        <div onClick={onClick}>
          <Typography color="white" variant="h4" className="flex">
            <span
              className={cn(
                'SpeakerTag--Text py-0.5 px-2 rounded-lg truncate w-full inline-block no-underline',
                bgClass,
              )}
            >
              {speaker.name}
            </span>
          </Typography>
        </div>
      )}
    </div>
  );
};

export default SpeakerTag;
